var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 13.5,
    r: 12.5,
    fill: "white",
    stroke: "#1A2746",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2109_1729)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 8.33217C8 7.94606 8.13514 7.62753 8.40541 7.37657C8.67567 7.1256 9.02703 7.00012 9.45946 7.00012C9.88417 7.00012 10.2278 7.12367 10.4903 7.37078C10.7606 7.6256 10.8958 7.95764 10.8958 8.36692C10.8958 8.73757 10.7645 9.04645 10.5019 9.29356C10.2317 9.54838 9.87645 9.6758 9.43629 9.6758H9.42471C9 9.6758 8.65637 9.54838 8.39382 9.29356C8.13127 9.03873 8 8.71826 8 8.33217ZM8.15058 18.4673V10.7299H10.722V18.4673H8.15058ZM12.1467 18.4673H14.7181V14.1468C14.7181 13.8766 14.749 13.6681 14.8108 13.5214C14.9189 13.2588 15.083 13.0368 15.3031 12.8553C15.5232 12.6739 15.7992 12.5831 16.1313 12.5831C16.9961 12.5831 17.4286 13.1661 17.4286 14.3322V18.4673H20V14.031C20 12.8881 19.7297 12.0214 19.1892 11.4306C18.6486 10.8399 17.9344 10.5445 17.0463 10.5445C16.0502 10.5445 15.2741 10.9731 14.7181 11.8302V11.8534H14.7066L14.7181 11.8302V10.7299H12.1467C12.1622 10.977 12.1699 11.7453 12.1699 13.0349C12.1699 14.3244 12.1622 16.1352 12.1467 18.4673Z",
    fill: "#0D2548"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2109_1729"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 11.4672,
    fill: "white",
    transform: "translate(8 7.00012)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonLinkedin);
export default __webpack_public_path__ + "static/media/button-linkedin.3375823733b711cc36a4f4570719ba97.svg";
export { ForwardRef as ReactComponent };